import { translate } from "app/filters/i18nFilter";
import { DropdownItem } from "pro-features/components/MultiChipDown/src/MultiChipDown";
import type {
    IItems,
    IItem,
} from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/types";

export const items: IItems<IGenderID> = [
    {
        id: "all",
        textKey: "demographics.user.based.compare.table.filters.gender.all",
    },
    {
        id: "male",
        textKey: "demographics.user.based.compare.table.filters.gender.male",
    },
    {
        id: "female",
        textKey: "demographics.user.based.compare.table.filters.gender.female",
    },
];

export type IGenderID = "all" | "male" | "female";

const RenderItemHof = (isAllAgesSelected: boolean) => (item: IItem<IGenderID>) => {
    const { id, textKey } = item;
    return (
        <span
            id={id}
            key={id}
        >
            <DropdownItem
                id={id}
                disabledTooltip={translate("demographics.user.based.compare.table.filters.gender.disable")}
                disabled={isAllAgesSelected && id === "all"}
                text={translate(textKey)}
                showCheckBox={false}
            />
        </span>
    );
};

export const getGenderFilterItems = (isAllAgesSelected) => {
    return items.map(RenderItemHof(isAllAgesSelected));
};
